// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2LEAs","colMaxWidth":"Table_colMaxWidth__1M4K9"};